import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Image from '@base/Image';
import P2 from '@base/P2/P2';
import H4 from '@base/H4/H4';
import Link from '@base/Link/Link';
import CheckBig from '@icon/CheckBig';

const List = styled.div`
  display: grid;
  grid-column: span 16;
  grid-row-gap: ${Spacings.SPACING_10};
`;
const Wrapper = styled.div`
  display: grid;
  grid-column: span 16;
  grid-row-gap: ${Spacings.SPACING_10};
  background: var(--color-base-1);
  color: var(--color-text-primary);
  line-height: 150%;
  font-size: ${Fonts.ULTRA_SMALL};
  font-weight: normal;
  height: 196px;
  background-color: var(--color-base-1);
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
  box-shadow: ${Spacings.SPACING_0B} ${Spacings.SPACING_4B}
    ${Spacings.SPACING_8B} ${Spacings.SPACING_0B} var(--color-shadow);
  border-radius: ${Spacings.SPACING_2B};
  cursor: pointer;
  transition: box-shadow 0.2s ease-in-out;
  grid-template-columns: 120px auto;
  column-gap: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    height: 144px;
    grid-template-columns: 90px auto;
    column-gap: ${Spacings.SPACING_3B};
  }
`;

const ListWrapper = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-row-gap: ${Spacings.SPACING_6B};
`;
const Title = styled(H4)`
  grid-column: span 16;
`;

const EducatorList = ({ authors, goalUID }) => {
  if (!authors.length) return null;
  return (
    <ListWrapper>
      <Title>Educators</Title>
      <List>
        {Array.isArray(authors) &&
          authors.map((educator) => (
            <EducatorDetailed
              gridColumn="span 10"
              key={1}
              educator={educator}
              showBadge
              goalUID={goalUID}
            />
          ))}
      </List>
    </ListWrapper>
  );
};

const Profile = styled(Image)`
    height: 160px;
    width: 120px;
    border-radius: ${Spacings.SPACING_2B};
    object-fit: cover;
    ${mediaQuery.uptoMobile} {
    background-color: var(--color-base-0);
    box-shadow: none;
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B} ${Spacings.SPACING_0B};
    ${mediaQuery.uptoMobile} {
      height: 120px;
      width: 90px;  
      border-radius: ${Spacings.SPACING_6};
      padding: ${Spacings.SPACING_0B};
  }
  }
}`;
const Info = styled.div`
  display: grid;
  grid-template-rows: ${Spacings.SPACING_8B} auto;
  ${mediaQuery.uptoMobile} {
    grid-template-rows: ${Spacings.SPACING_5B} auto;
  }
`;
const Name = styled(H4)`
  grid-row: 1/2;
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;

const VerifiedIcon = styled(CheckBig)`
  margin-left: ${Spacings.SPACING_1B};
`;
const AuthorDetails = styled(P2)`
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--color-text-secondary);
  ${mediaQuery.uptoMobile} {
    -webkit-line-clamp: 4;
    max-height: ${Spacings.SPACING_18B};
  }
`;
const EducatorDetailed = ({ educator }) => {
  const {
    avatar,
    name,
    is_verified_educator: isVerifiedEducator,
    bio,
    username
  } = educator;
  return (
    <Link href="/[authorID]" as={`/@${username}`}>
      <Wrapper>
        <Profile src={avatar} alt="educator" height={160} width={120} />
        <Info>
          <Name color="var(--color-text-primary)">
            {name}
            {isVerifiedEducator && <VerifiedIcon color="var(--color-i-blue)" />}
          </Name>
          <AuthorDetails title={bio}>{bio}</AuthorDetails>
        </Info>
      </Wrapper>
    </Link>
  );
};
export default EducatorList;
